import { useNav } from '../stores/navigation';
import { useUnlocked } from '../stores/unlocked';
import { entryKey } from '../qr/parser';
import { bodyTextureUrl } from '../character/constants';

export function CollectionScreen() {
  const go = useNav((s) => s.go);
  const entries = useUnlocked((s) => s.entries);
  const clear = useUnlocked((s) => s.clear);

  return (
    <div className="screen">
      <button
        className="btn btn-secondary"
        onClick={() => go({ kind: 'home' })}
        style={{ alignSelf: 'flex-start' }}
      >
        ← 戻る
      </button>
      <h2 className="screen-title">コレクション</h2>

      {entries.length === 0 ? (
        <p className="muted center" style={{ flex: 1 }}>
          まだ何もありません。QR をスキャンして追加してください。
        </p>
      ) : (
        <div
          style={{
            flex: 1,
            minHeight: 0,
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(min(160px, 40vw), 1fr))',
            gridAutoRows: 'min-content',
            alignContent: 'start',
            gap: 'clamp(8px, 2vw, 14px)',
            overflowY: 'auto',
            WebkitOverflowScrolling: 'touch',
            paddingBottom: 12,
          }}
        >
          {entries.map((e) => (
            <button
              key={entryKey(e)}
              className="collection-card"
              onClick={() => go({ kind: 'detail', entry: e })}
              style={{ backgroundImage: `url(${bodyTextureUrl(e.b)})` }}
            >
              <div className="collection-card__scrim" />
              <div className="collection-card__label">
                <div className="collection-card__label-primary">
                  m{e.m} / {e.b}
                </div>
                <div className="collection-card__label-secondary">
                  f{e.f} / h{e.h}w{e.w}
                </div>
              </div>
            </button>
          ))}
        </div>
      )}

      {entries.length > 0 && (
        <button
          className="btn btn-danger btn-block"
          onClick={() => {
            if (confirm('コレクションを全て削除しますか？')) clear();
          }}
          style={{ marginTop: 16, flexShrink: 0 }}
        >
          コレクションを初期化
        </button>
      )}
    </div>
  );
}
